/** @format */
import { Address } from './address';
import { LineItemState } from './line-item';
import { TaxSummary } from './tax-item';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum PublicConsignmentState {
    UNDEFINED,
    PENDING,
    BOOKED,
    IN_TRANSIT,
    COMPLETE,
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum DeliveryType {
    UNDEFINED_TYPE = 'UNDEFINED_TYPE',
    COLLECTION = 'COLLECTION',
    SHIPMENT = 'SHIPMENT',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface DeliveryChargeItem {
    currency: string;
    id: string;
    state: LineItemState;
    taxes: TaxSummary[];
    value: number;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface DeliverySummary {
    id: string;
    deliveryType?: DeliveryType;
    address?: Address;
    numParcels: number;
    deliveryOption: number;
    deliveryExpected: string | null;
    shippedOn: string | null;
    chargeItem?: DeliveryChargeItem;
    state: PublicConsignmentState;
    labelUrl?: string;
    invoiceUrl?: string;
    qrUrl?: string;
}
